const replaceText = (text: string, first_name: string, last_name: string, course_name: string) => {
  return text
    .replaceAll(/{{{course_name}}}/gi, `<strong style="color: white;">${course_name}</strong>`)
    .replaceAll(/{{{first_name}}}/gi, first_name)
    .replaceAll(/{{{last_name}}}/gi, last_name);
};

export const awardEmail = (
  textBody: string,
  channelLogo = 'https://assets.brandlive.com/assets/bl-logo-sunset.png',
  bannerImage = 'https://assets.brandlive.com/assets/bl-platform/images/limelight-banner.webp',
  firstName = 'John',
  lastName = 'Doe',
  courseName = 'The Course',
  url = 'about:blank',
  buttonColor = 'var(--product-acc-400)',
  buttonTextColor = 'var(--gray-100)'
) => `<table
  align="center"
  width="100%"
  border="0"
  cellspacing="0"
  cellpadding="0"
  bgcolor="#1a1a1f"
  class="em_full_wrap"
  id="container"
  style="background-color: #1a1a1f;
	table-layout: auto; width: 100%"
>
  <tr>
    <td align="center" valign="top">
      <table
        align="center"
        width="600"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="em_main_table"
        id="outer-body"
        style="width: 600px; table-layout: fixed"
      >
        <tr>
          <td
            align="center"
            valign="top"
            height="40"
            class="em_h40"
            style="font-size: 0px; line-height: 0px"
          ></td>
        </tr>
        <tr>
          <td align="center" valign="top">
            <img
              src="${channelLogo}"
              alt="BrandLive"
              width="91px"
              style="max-width: 91px; display: block"
            />
          </td>
        </tr>
        <tr>
          <td
            align="center"
            valign="top"
            height="28"
            class="em_h28"
            style="font-size: 0px; line-height: 0px"
          ></td>
        </tr>
        <tr>
          <td align="center" valign="top" style="padding: 0px 20px">
            <table
              align="center"
              width="100%"
              border="0"
              cellspacing="0"
              cellpadding="0"
              bgcolor="#26242B"
              id="inner-body"
              style="background-color: rgb(38, 36, 43); border-radius: 12px"
            >
              <tr>
                <td
                  align="center"
                  valign="top"
                  class="em_pad"
                  style="padding: 40px"
                >
                  <table
                    align="center"
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td align="center" valign="top">
                        <table
                          align="center"
                          width="100%"
                          border="0"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <tr>
                            <td align="center" valign="top" width="100%">
                              <table
                                align="center"
                                width="100%"
                                border="0"
                                cellspacing="0"
                                cellpadding="0"
                              >
                                <tr>
                                  <td
                                    align="center"
                                    valign="top"
                                    width="48"
                                    style="font-size: 0px; line-height: 0px"
                                  ></td>
                                  <td align="center" valign="top" width="100%">
                                    <table
                                      align="center"
                                      width="100%"
                                      border="0"
                                      cellspacing="0"
                                      cellpadding="0"
                                      id="banner-image"
                                    >
                                      <td
                                        height="130px"
                                        width="100%"
                                        style="
                                          background-image: url('${bannerImage}');
                                          background-size: cover;
                                          background-repeat: no-repeat;
                                          background-position: center center;
                                          height: 130px;
                                          width: 100%;
                                          border-radius: 16px;
                                        "
                                      ></td>
                                    </table>
                                  </td>
                                  <td
                                    align="center"
                                    valign="top"
                                    width="48"
                                    style="font-size: 0px; line-height: 0px"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              align="center"
                              valign="top"
                              height="30"
                              class="em_h20"
                              style="font-size: 0px; line-height: 0px"
                            ></td>
                          </tr>
                          <tr>
                            <td align="center" valign="top" width="100%">
                              <table
                                align="center"
                                width="100%"
                                border="0"
                                cellspacing="0"
                                cellpadding="0"
                              >
                                <tr>
                                  <td
                                    align="center"
                                    valign="top"
                                    height="50"
                                    width="50"
                                    style="font-size: 0px; line-height: 0px"
                                  ></td>
                                  <td align="center" valign="top" width="100%">
                                    <table
                                      align="center"
                                      width="432px"
                                      border="0"
                                      cellspacing="0"
                                      cellpadding="0"
                                    >
                                      <tr>
                                        <td
                                          align="center"
                                          valign="top"
                                          style="
                                            font-weight: 500;
                                            font-size: 14px;
                                            line-height: 24px;
                                            font-family: Arial, sans-serif;
                                            color: rgb(191, 187, 207);
                                            white-space: pre-wrap;
                                            text-align: center;
                                          "
                                        >${replaceText(textBody, firstName, lastName, courseName)}</td>
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          valign="top"
                                          height="24"
                                          style="
                                            font-size: 0px;
                                            line-height: 0px;
                                          "
                                        ></td>
                                      </tr>
                                      <table
                                        align="center"
                                        border="0"
                                        cellspacing="0"
                                        cellpadding="0"
                                        bgcolor="#5ae4ff"
                                        style="
                                          font-size: 16px;
                                          background-color: ${buttonColor};
                                          border-radius: 100px;
                                        "
                                      >
                                        <tr>
                                          <td
                                            align="center"
                                            valign="middle"
                                            height="47"
                                          >
                                            <a
                                              href="${url}"
                                              target="_blank"
                                              rel="noreferrer"
                                              style="
                                                pointer-events: none;
                                                height: auto;
                                                padding: 15px 24px;
                                                font-size: 13px;
                                                line-height: 16px;
                                                font-weight: 600;
                                                display: block;
                                                color: ${buttonTextColor};
                                                text-decoration: none;
                                                font-family: Arial, sans-serif;
                                              "
                                              >Download certificate</a>
                                          </td>
                                        </tr>
                                      </table>
                                      <tr>
                                        <td
                                          align="center"
                                          valign="top"
                                          height="15"
                                          style="
                                            font-size: 0px;
                                            line-height: 0px;
                                          "
                                        ></td>
                                      </tr>
                                    </table>
                                  </td>
                                  <td
                                    align="center"
                                    valign="top"
                                    height="50"
                                    width="50"
                                    style="font-size: 0px; line-height: 0px"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td
            align="center"
            valign="top"
            class="em_pad"
            style="padding-top: 15px"
          >
            <table
              align="center"
              width="600"
              border="0"
              cellspacing="0"
              cellpadding="0"
              style="width: 600px; max-width: 100%"
            >
              <tr>
                <td
                  align="left"
                  valign="middle"
                  style="
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 16px;
                    letter-spacing: -0.2px;
                    color: rgb(98, 94, 112);
                    font-family: Arial, sans-serif;
                    padding-left: 20px;
                  "
                >
                  Sent by Brandlive Inc., 3303 N Mississippi Ave Ste 200,
                  Portland, OR&nbsp;97227
                </td>
                <td
                  align="center"
                  valign="top"
                  width="15"
                  style="font-size: 0px; line-height: 0px"
                ></td>
                <td align="right" valign="middle" style="padding-right: 20px">
                  <a
                    href="#"
                    target="_blank"
                    style="text-decoration: none; color: rgb(255, 255, 255)"
                    ><img
                      src="https://assets.brandlive.com/assets/emails/invitation/brandlive_logo_grey.png"
                      alt="BrandLive"
                      border="0"
                      width="66"
                      style="
                        max-width: 66px;
                        display: block;
                        font-size: 20px;
                        line-height: 28px;
                        font-weight: bold;
                        color: rgb(255, 255, 255);
                      "
                  /></a>
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  valign="top"
                  height="57px"
                  style="height: 57px; font-size: 0px; line-height: 0px"
                ></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td
            class="em_hide"
            style="
              line-height: 1px;
              min-width: 600px;
              background-color: rgb(26, 26, 31);
            "
          >
            <img
              alt=""
              src="https://assets.brandlive.com/assets/emails/invitation/spacer.gif"
              height="1"
              width="600"
              border="0"
              style="
                max-height: 1px;
                min-height: 1px;
                display: block;
                width: 600px;
                min-width: 600px;
              "
            />
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`;
